import React from 'react';
import { createPortal } from 'react-dom';

export type ProfaseModalSize = 'default' | 'compact' | 'wide' | 'large' | 'xlarge' | 'full';

const sizeClasses: Record<ProfaseModalSize, string> = {
  default: '',
  compact: 'profase-modal-dialog--compact',
  wide: 'profase-modal-dialog--wide',
  large: 'profase-modal-dialog--large',
  xlarge: 'profase-modal-dialog--xlarge',
  full: 'profase-modal-dialog--full',
};

export interface ProfaseModalProps {
  open: boolean;
  children: React.ReactNode;
  onBackdropMouseDown?: (e: React.MouseEvent) => void;
  titleId?: string;
  size?: ProfaseModalSize;
  scroll?: boolean;
  zIndex?: number;
  dialogClassName?: string;
  dialogStyle?: React.CSSProperties;
}

export default function ProfaseModal({
  open,
  children,
  onBackdropMouseDown,
  titleId,
  size = 'default',
  scroll = false,
  zIndex = 100000,
  dialogClassName = '',
  dialogStyle,
}: ProfaseModalProps) {
  if (!open) return null;

  const dialogClasses = ['profase-modal-dialog', sizeClasses[size], dialogClassName]
    .filter(Boolean)
    .join(' ');

  return createPortal(
    <div
      role="presentation"
      className={[
        'profase-modal-backdrop',
        scroll ? 'profase-modal-backdrop--scroll' : '',
        size === 'full' ? 'profase-modal-backdrop--full' : '',
      ].filter(Boolean).join(' ')}
      style={{ zIndex }}
      onMouseDown={onBackdropMouseDown}
    >
      <div
        role="dialog"
        aria-modal
        aria-labelledby={titleId}
        className={dialogClasses}
        style={dialogStyle}
        onMouseDown={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
